(function () {
    'use strict';

    angular
        .module('surveyControllers')
        .controller('AvailableSurveysController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'availableSurveys',];

    function Controller($scope, $state, topBarService, availableSurveys) {

        topBarService.setTitleAndIcon('Available Surveys', 'fa fa-bullhorn');

        if (!_.isUndefined(availableSurveys) && availableSurveys.length === 1) {
            var availableSurvey = availableSurveys[0];
            $state.go('survey.forRespondent', availableSurvey.Campaign.SlugObject);
            return;
        }

        $scope.availableSurveys = availableSurveys;
    }
})();